// extracted by mini-css-extract-plugin
export var buttons = "V_ct";
export var column = "V_b0";
export var columns = "V_bZ";
export var container = "V_k";
export var down = "V_dg";
export var download = "V_df";
export var footer = "V_dc";
export var information = "V_dd";
export var section = "V_b";
export var show = "V_L";
export var text = "V_cq";
export var title = "V_f";
export var units = "V_dh";
export var up = "V_dk";
export var upload = "V_dj";
export var waveOne = "V_q";
export var waveThree = "V_c2";
export var waveTwo = "V_n";
export var waves = "V_c1";